import { themesList } from '../data/contentData';

export const getThemesAlphabetically = (language) => {
    return themesList.sort((a, b) =>
        language === 'DE'
            ? (a.themeTitleGerman > b.themeTitleGerman) ? 1 : -1
            : (a.themeTitleEn > b.themeTitleEn) ? 1 : -1)
}